// extracted by css-extract-rspack-plugin
export default {"SubmitReviewButton":"ReviewMenuFooter-module__SubmitReviewButton__KIlAr","ErrorMessage":"ReviewMenuFooter-module__ErrorMessage__R9Bye"};